import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red-600 font-semibold"
}
const _hoisted_2 = {
  key: 1,
  class: "text-orange-600 font-semibold"
}
const _hoisted_3 = {
  key: 2,
  class: "text-orange-600 font-semibold"
}
const _hoisted_4 = {
  key: 3,
  class: "text-green-600 font-semibold"
}

import { PropType } from 'vue';
import { Qualifier } from '@/model/Spf';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpfQuantifier',
  props: {
  qualifier: {
    type: String as PropType<Qualifier>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.qualifier === 'Fail')
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "fail"))
    : (__props.qualifier === 'Softfail')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "softfail"))
      : (__props.qualifier === 'Neutral')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "neutral"))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "pass"))
}
}

})